import React from 'react';
import classNames from 'classnames';

type IProps = {
  className?: string;
};

const NewBadge: React.FC<IProps> = ({ className = '' }) => (
  <div className={classNames(['app-sidebar__new-badge', className])}>
    <span>New</span>
  </div>
);

export default NewBadge;
